import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { urlApiJobDetails } from '~/utils/constants/apis';

export interface IPaymentHistoryItem {
  id: string | number;
  type: string | null;
  contactName: string | null;
  relatedJob: string | null;
  relatedInvoice: string | null;
  amountGross: number;
  merchantFees: number | null;
  customerFees: number | null;
  amountNet: number;
  status: string | null;
  referenceId: string | null;
  payoutDate: string;
  currency?: string;
  source?: string;
  invoiceId?: number | string | null;
  jobId?: number | string | null;
}

export interface IGetPaymentHistoriesParams {
  startDate?: string;
  endDate?: string;
  status?: string;
  eventType?: string;
}

const stripeApi = {
  getPaymentHistories(params?: IGetPaymentHistoriesParams) {
    return axiosClient.get<IApiBaseResponse<IPaymentHistoryItem[]>>(
      urlApiJobDetails.getPaymentHistories,
      { params }
    );
  },
};

export default stripeApi;
